if (!customElements.get('ly-learn-more-quiz')) {
    customElements.define('ly-learn-more-quiz', class extends HTMLElement {

        #media = window.matchMedia('(max-width: 767px)')

        connectedCallback() {
            this.init()

            this.handleScroll()
            window.addEventListener('scroll', this.handleScroll, { passive: true })
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.handleScroll)
        }

        init = () => {
            this.noticebarHeightM = +this.dataset.noticebarHeightM
            this.noticebarHeightD = +this.dataset.noticebarHeightD
            this.headerHeight = +this.dataset.headerHeight
        }

        get noticebarHeight() {
            return this.#media.matches ? this.noticebarHeightM : this.noticebarHeightD
        }

        #ticking = false

        handleScroll = () => {
            if (this.#ticking) return

            this.#ticking = true
            requestAnimationFrame(() => {
                this.update()
                this.#ticking = false
            })
        }

        #lastTop = null

        update = () => {
            const top = this.headerHeight + Math.max(this.noticebarHeight - document.documentElement.scrollTop, 0)

            if (this.#lastTop !== top) {
                this.style.setProperty('--drawer-top', top + 'px')
                this.#lastTop = top
            }
        }
    })
}

if (!customElements.get('ly-learn-more-quiz-item')) {
    customElements.define('ly-learn-more-quiz-item', class extends HTMLElement {
        connectedCallback() {
            this.drawerTrigger = this.querySelector('form[data-drawer-trigger]')
            this.drawer = this.querySelector('[data-drawer]')

            this.drawerTrigger.addEventListener('submit', this.handleTriggerDrawer)
        }

        disconnectedCallback() {
            this.drawerTrigger.removeEventListener('submit', this.handleTriggerDrawer)
        }

        handleTriggerDrawer = (evt) => {
            evt.preventDefault()

            if (!this.drawer) return

            this.drawer.open?.()
        }
    })
}

if (!customElements.get('ly-learn-more-quiz-item-drawer')) {
    customElements.define('ly-learn-more-quiz-item-drawer', class extends HTMLElement {
        connectedCallback() {
            this.questionStep = this.querySelector('[data-drawer-step="question"]')
            this.loadingStep = this.querySelector('[data-drawer-step="loading"]')
            this.resultStep = this.querySelector('[data-drawer-step="result"]')
            this.closeBtn = this.querySelector('[data-close-btn]')

            this.progressWrapper = this.querySelector('[data-progress]')
            this.progressBar = this.querySelector('[data-progress-bar]')
            this.progressText = this.querySelector('[data-progress-text]')
            this.progressTextCurrent = this.progressText.querySelector('.current')

            this.reset()

            this.addEventListener('finish_question', this.handleFinishQuestion)
            this.addEventListener('update_progress', this.handleUpdateProgress)
            this.closeBtn.addEventListener('click', this.close)
        }

        disconnectedCallback() {
            this.removeEventListener('finish_question', this.handleFinishQuestion)
            this.removeEventListener('update_progress', this.handleUpdateProgress)
            this.closeBtn.removeEventListener('click', this.close)
        }

        reset = () => {
            this.questionStep.classList.add('is-active')
            this.loadingStep.classList.remove('is-active')
            this.resultStep.classList.remove('is-active')

            this.questionStep.init?.()

            this.progressWrapper.classList.remove('ly-hide')
            this.handleUpdateProgress()
        }

        handleFinishQuestion = async (evt) => {
            evt.preventDefault()
            evt.stopPropagation()

            this.progressWrapper.classList.add('ly-hide')

            this.questionStep.classList.remove('is-active')
            this.loadingStep.classList.add('is-active')

            await Promise.all([this.resultStep.renderResult?.(this.questionStep.qaData), wait(2500)])

            this.loadingStep.classList.remove('is-active')
            this.resultStep.classList.add('is-active')
        }

        handleUpdateProgress = () => {
            const current = this.questionStep.current
            this.progressBar.style.setProperty('--current', current)
            this.progressTextCurrent.textContent = current
        }

        open = () => {
            this.classList.add('is-active')
            this.reset()
        }

        close = () => {
            this.classList.remove('is-active')
        }
    })
}

if (!customElements.get('ly-learn-more-quiz-item-drawer-questions')) {
    customElements.define('ly-learn-more-quiz-item-drawer-questions', class extends HTMLElement {
        connectedCallback() {
            this.questions = [...this.querySelectorAll('ly-learn-more-quiz-item-drawer-question')]
            this.init()
            this.addEventListener('next-question', this.handleNextQuestion)
        }

        disconnectedCallback() {
            this.removeEventListener('next-question', this.handleNextQuestion)
        }

        init = () => {
            this.current = 1
            this.total = this.questions.length
            this.qaData = {}
            this.formData = {}

            this.update()

            this.questions.forEach(q => q.init?.())
        }

        handleNextQuestion = (evt) => {
            evt.preventDefault()
            evt.stopPropagation()

            const { qaData, formData, current } = evt.detail

            Object.assign(this.qaData, qaData)
            Object.assign(this.formData, formData)
            this.next(current)
        }

        next = (current) => {
            if (current >= this.total) {
                this.dispatchEvent(new CustomEvent('finish_question', {
                    bubbles: true
                }))

                const form = {}
                Object.entries(this.formData).forEach(([key, value]) => {
                    if (key === 'first_name') {
                        key = 'name'
                    }
                    form[key] = value.join(';')
                })
                API.addLearnMoreQuiz(form)

                return
            }
            this.current = current + 1

            this.update()

            this.dispatchEvent(new CustomEvent('update_progress', {
                bubbles: true
            }))
        }

        update = () => {
            this.questions.forEach(q => {
                q.classList.toggle('is-active', +q.dataset.index === this.current)
            })
        }
    })
}

if (!customElements.get('ly-learn-more-quiz-item-drawer-question')) {
    customElements.define('ly-learn-more-quiz-item-drawer-question', class extends HTMLElement {

        #checkboxs = []

        connectedCallback() {
            this.form = this.querySelector('form')
            this.#checkboxs = [...this.form.querySelectorAll('input[type="checkbox"]')]
            this.form.addEventListener('submit', this.handleSubmit)
        }

        disconnectedCallback() {
            this.form.removeEventListener('submit', this.handleSubmit)
        }

        init = () => {
            this.form.reset()
        }

        get atLeastCheckedOneBox() {
            return !!this.#checkboxs.filter(item => item.checked).length
        }

        handleSubmit = (evt) => {
            evt.preventDefault()
            if (this.#checkboxs.length && !this.atLeastCheckedOneBox) {
                return
            }

            const fd = new FormData(this.form)
            const data = {}
            const answerHandles = []
            for (const [key, value] of fd.entries()) {
                const [answer, answerHandle] = value.split('@handle=')
                if (!data[key]) {
                    data[key] = []
                }
                data[key].push(answer)
                answerHandles.push(answerHandle)
            }

            const qaData = {}
            qaData[this.dataset.handle] = answerHandles

            this.dispatch(qaData, data)
        }

        dispatch = (qaData, formData) => {
            this.dispatchEvent(new CustomEvent('next-question', {
                bubbles: true,
                detail: {
                    qaData,
                    formData,
                    current: +this.dataset.index
                }
            }))
        }
    })
}

if (!customElements.get('ly-learn-more-quiz-item-drawer-result')) {
    customElements.define('ly-learn-more-quiz-item-drawer-result', class extends HTMLElement {
        connectedCallback() {
            this.script = this.querySelector('script')
            this.results = readJsonFromScript(this.script)
            this.renderWrapper = this.querySelector('[data-render-wrapper]')

            this.render()
        }

        disconnectedCallback() {

        }

        renderResult = (formData) => {
            return new Promise((resolve) => {
                const result = this.results.find(({ handles: { questionHandles, answerHandles } }) => {
                    const selectedAnswers = []
                    questionHandles.forEach(qh => {
                        selectedAnswers.push(...formData[qh])
                    })
                    return selectedAnswers.sort().join('/') === answerHandles.sort().join('/')
                })
                this.render(result)
                resolve()
            })
        }

        render = (result) => {
            if (!result) {
                result = this.results[0]
            }
            this.renderWrapper.innerHTML = `
            ${this.renderIcon(result)}
            ${this.renderTitle(result)}
            ${this.renderProducts(result)}

            ${this.renderFinalBtn(result)}
            `
        }

        renderIcon = (result) => {
            if (result.svg) return ''
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-icon">
              <span class="svg-wrapper">
                ${result.svg}
              </span>
            </div>
            `
        }

        renderTitle = (result) => {
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-title">
              ${result.title}
            </div>
            <div class="ly-learn-more-quiz-item-drawer-result-subtitle">
              ${result.subtitle}
            </div>
            <div class="ly-learn-more-quiz-item-drawer-result-analysis">
              <div class="ly-learn-more-quiz-item-drawer-result-analysis__title">
                <div class="ly-learn-more-quiz-item-drawer-result-analysis__title-inner">
                  ${result.result_analysis_title}
                </div>
              </div>
              <div class="ly-learn-more-quiz-item-drawer-result-analysis__value">
                <div class="ly-learn-more-quiz-item-drawer-result-analysis__value-inner">
                  ${result.result_analysis_value}
                </div>
              </div>
            </div>
            <div class="ly-learn-more-quiz-item-drawer-result-answer-title">
              ${result.answer_title}
            </div>
            <div class="ly-learn-more-quiz-item-drawer-result-answer-text">
              ${result.answer_text}
            </div>
            `
        }

        renderProducts = (result) => {
            if (!result.products.length) return ''
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-products">
              <div class="ly-learn-more-quiz-item-drawer-result-products-grid">
                ${result.products.map(this.renderProduct).join('')}
              </div>
            </div>
            `
        }

        renderProduct = (product) => {

            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product">
              ${this.renderProductImage(product)}
              ${this.renderProductContent(product)}
            </div>
            `
        }

        renderProductImage = (product) => {
            const widths = [360, 440, 720, 880, 1080]
            const src = `${product.image}&width=${widths[0]}`
            const srcset = widths.map(w => `${product.image}&width=${w} ${w}w`).join('')

            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-image">
              <img
                src="${src}"
                srcset="${srcset}"
                sizes="(max-width: 767px) 360px, 438px"
                width="438"
                height="280"
              >
            </div>
            `
        }

        renderProductContent = (product) => {
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-content">
              ${this.renderProductContentTagTitle(product)}
              <div class="ly-learn-more-quiz-item-drawer-result-product-title">
                ${product.title}
              </div>
              ${this.renderProductContentOptions(product)}
              ${this.renderProductContentSvgTags(product)}
              <div class="ly-learn-more-quiz-item-drawer-result-product-price">
                <span class="from">From</span>
                <span class="min">${product.price.min}</span>
                <span class="divider">-</span>
                <span class="max">${product.price.max}</span>
              </div>
              ${this.renderProductContentDescription(product)}
              <a
                href="${product.url}"
                class="ly-learn-more-quiz-item-drawer-result-product-view-btn ly-learn-more-quiz-btn"
              >
                <span class="ly-learn-more-quiz-btn-text">
                  ${product.btn_text}
                </span>
              </a>
            </div>
            `
        }

        renderProductContentTagTitle = (product) => {
            if (!product.tag_title) return ''
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-tag-title">
              ${product.tag_title}
            </div>
            `
        }

        renderProductContentOptions = (product) => {
            if (!product.options.length) return ''
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-options">
              ${product.options.map(this.renderProductContentOption).join('')}
            </div>
            `
        }

        renderProductContentOption = (option) => {
            const widths = [300, 40, 60, 80, 90]
            const src = `${option}&width=${widths[0]}`
            const srcset = widths.map(w => `${option}&width=${w} ${w}w`).join('')
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-option">
              <img
                src="${src}"
                srcset="${srcset}"
                sizes="(max-width: 767px) 30px, 40px"
                width="40"
                height="40"
              >
            </div>
            `
        }

        renderProductContentSvgTags = (product) => {
            if (!product.svg_tags.length) return ''
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-svg-tags">
              ${product.svg_tags.map(this.renderProductContentSvgTag).join('')}
            </div>
            `
        }

        renderProductContentSvgTag = (tag) => {
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-svg-tag">
              <div class="ly-learn-more-quiz-item-drawer-result-product-svg-tag-icon svg-wrapper">
                ${tag.svg}
              </div>
              <div class="ly-learn-more-quiz-item-drawer-result-product-svg-tag-title">
                ${tag.title}
              </div>
            </div>
            `
        }

        renderProductContentDescription = (product) => {
            if (!product.description) return ''
            return `
            <div class="ly-learn-more-quiz-item-drawer-result-product-description ly-p-v2">
              ${product.description}
            </div>
            `
        }

        renderFinalBtn = (result) => {
            if (!result.final_btn_text) {
                return ''
            }

            return `
            <a
              class="ly-learn-more-quiz-item-drawer-result-final-btn ly-learn-more-quiz-btn"
              href="${result.final_btn_text_url}"
            >
              <span class="ly-learn-more-quiz-item-drawer-result-final-btn-text ly-learn-more-quiz-btn-text">
                ${result.final_btn_text}
              </span>

              <span class="ly-learn-more-quiz-item-drawer-result-final-btn-icon ly-learn-more-quiz-btn-icon">
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M-0.000156164 3.54011H9.70484L7.46984 1.29011L8.72984 0.000107229L13.1848 4.53011L8.72984 9.04511L7.46984 7.77011L9.73484 5.46011H-0.000156164V3.54011Z" fill="currentColor"/>
                </svg>
              </span>
            </a>
            `
        }
    })
}